export interface ISupportCategory {
    supportCategoryId: number;
    issueWith: string;
}